import { Color } from "../../defines/colors"
import { ItemType } from "../../defines/enums"
import { Symbol } from "../../defines/symbols"
import { Position, RenderConfig } from "../../defines/types"
import { Item } from "./item"

export class Optic extends Item {
  constructor(type: ItemType, position: Position) {
    const render = getOpticRenderConfig(type)
    const name = getOpticName(type)
    const levelRequired = 1
    super(type, levelRequired, position, render, name)
  }
}

function getOpticRenderConfig(type: ItemType): RenderConfig {
  let light: string = Color.ANY
  let dark: string = Color.ANY_DARK

  switch (type) {
    case ItemType.OPTIC_RED:
      light = Color.OPTIC_RED
      dark = Color.OPTIC_RED_DARK
      break
    case ItemType.OPTIC_GREEN:
      light = Color.OPTIC_GREEN
      dark = Color.OPTIC_GREEN_DARK
      break
    case ItemType.OPTIC_BLUE:
      light = Color.OPTIC_BLUE
      dark = Color.OPTIC_BLUE_DARK
      break
    case ItemType.OPTIC_MAGENTA:
      light = Color.OPTIC_MAGENTA
      dark = Color.OPTIC_MAGENTA_DARK
      break
    case ItemType.OPTIC_CYAN:
      light = Color.OPTIC_CYAN
      dark = Color.OPTIC_CYAN_DARK
      break
    case ItemType.OPTIC_YELLOW:
      light = Color.OPTIC_YELLOW
      dark = Color.OPTIC_YELLOW_DARK
      break
    default:
      break
  }

  return { symbol: [Symbol.OPTIC], light: light, dark: dark }
}

function getOpticName(type: ItemType): string {
  let name = ""

  switch (type) {
    case ItemType.OPTIC_RED:
      name = "red optic"
      break
    case ItemType.OPTIC_GREEN:
      name = "green optic"
      break
    case ItemType.OPTIC_BLUE:
      name = "blue optic"
      break
    case ItemType.OPTIC_MAGENTA:
      name = "magenta optic"
      break
    case ItemType.OPTIC_CYAN:
      name = "cyan optic"
      break
    case ItemType.OPTIC_YELLOW:
      name = "yellow optic"
      break
    default:
      break
  }

  return name
}
